<template>
    <CHeaderNav class="d-md-down-none mr-auto">
      <!--<CHeaderNavItem 
        v-for="menuItem in menuItems"
        v-bind:key="menuItem.name"
      >
        <CHeaderNavLink
          :href='menuItem.href'
        >
          {{ menuItem.name }}
        </CHeaderNavLink>
      </CHeaderNavItem>-->
    </CHeaderNav>
</template>

<script>

export default {
  name: 'Menu',
  mounted () {
  
  },
  computed: {
    
  }
}
</script>